import React, {useState, useEffect} from 'react'
import Select from 'react-select'
import { ColorChecker } from '../Helpers/Functions/ColorChecker';

export default function SquareProfile({users, visibleFields, team, custom_field_values, user_avatars, page, amounts, host}) {
  const [selectedUser, setSelectedUser] = useState(users[0]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [fieldValues, setFieldValues] = useState(custom_field_values)
  const [currentSelection, setCurrentSelection] = useState(null)
  const [buttonTextColor, setButtonTextColor] = useState('white')
  const [buttonColor, setButtonColor] = useState(page.button_color)

  useEffect(() => {
    let result = ColorChecker(buttonColor)
    if (result == true) setButtonTextColor('black')
  }, [])

  function canShowPublicField(customFields, field) {
    const foundField = customFields.find(
      (f) => f.system_key === field.toString()
    );
    return foundField && foundField.visible;
  }

  const getFieldValues = (user, field) => {
    if (field.system_key == 'bio') return user.bio
    const userRecords = [];

    for (const innerArray of fieldValues) {
        const matchingRecords = innerArray.filter(value => value.record_id == user.id);
        userRecords.push(...matchingRecords);
    }
    if (!userRecords) return null

    let valueObject = userRecords.find(record => record.team_custom_field_id == field.id)
    if (valueObject) return valueObject.value 
    return null
  }

  const getUserAvatar = (user) => {
    const matchingRecord = user_avatars.find(
      (record) => record.user_id === user.id
    );

    if (matchingRecord.user_avatar != null) {
      return matchingRecord.user_avatar;
    } else {
      return "https://www.connollymusic.com/hubfs/magic_rosin/user-silhouette.svg"
    }
  };

  const defineAge = (birthday) => {
    if (!birthday) {
      return "";
    }
    const age = Math.floor(
      (new Date() - new Date(birthday)) / (365 * 24 * 60 * 60 * 1000)
    );
    return age.toString();
  };

  const getAmounts = (amount = null) => {
    if (amount) {
      if (page.pass_processing_fee && page.use_stripe) {
        let raw_amount = parseFloat(amount.amount)
        let fee = (((raw_amount + 0.30) / (1 - 0.034)) - raw_amount).toFixed(2)
        let total = (parseFloat(raw_amount) + parseFloat(fee)).toFixed(2)
        return total;
      }
      return amount.amount;
    } else {
      if (page.pass_processing_fee && page.use_stripe) {
        let raw_amount = page.general_sponsorship_amount
        let fee = (((raw_amount + 0.30) / (1 - 0.034)) - raw_amount).toFixed(2)
        let total = (parseFloat(raw_amount) + parseFloat(fee)).toFixed(2)
        return total;
      }

      return page.general_sponsorship_amount;
    }
  };

  const unpaidSponsorshipsCount = (id) => {
    let sponsorships = amounts.filter(amount => amount.user_id == id && !amount.paid)
    return sponsorships.length > 0 ? sponsorships.length : 1
  }

  const totalSponsorshipCount = (id) => {
    let sponsorships = amounts.filter(amount => amount.user_id == id)
    return sponsorships.length > 0 ? sponsorships.length : 1
  }

  const userSponsorshipAmount = (user) => {
    let sponsorships = amounts.filter(amount => amount.user_id == user.id && !amount.paid)
    return sponsorships.length > 0 ? sponsorships : false
  }

  const handleInputChange = (value) => {
      setCurrentSelection(value)
  }

  const handleStaticChange = (value) => {

  }

  const visitSponsorPage = (user) => {
      let userSponsorships = amounts.filter(amount => amount.user_id == user.id && !amount.paid)
      if (!userSponsorships || (userSponsorships && userSponsorships.length < 1)) {
          return `/sponsor/${team.id}/${user.id}/${page.id}/signup/new`
      } else {
          let sponsorshipsWithId = userSponsorships.filter(amount => currentSelection && amount.id == currentSelection.id)
          if (sponsorshipsWithId && sponsorshipsWithId.length > 0) {
              return `/sponsor/${team.id}/${user.id}/${page.id}/signup/new?sponsorship_id=${sponsorshipsWithId[0].id}`
          } else {
              return `/sponsor/${team.id}/${user.id}/${page.id}/signup/new?sponsorship_id=${userSponsorships[0].id}`
          }
      }
  }

  const columnDivide = () => {
    let count = page.profiles_per_row && page.profiles_per_row < 7 && page.profiles_per_row > 0 ? page.profiles_per_row : 4
    return 12 / count
  }
  

  return (
    <div className='main-content mt-3 mb-3'>
      {!isModalOpen &&
        <div className="row row-projects">
          {users.map((user) => {
            let avatar = getUserAvatar(user);
            return (
              <div className={`col-sm-6 col-md-4 col-square-profile-5 mt-5`} key={user.id}>
                <div className="card" style={{width: '200px', margin: 'auto'}}>
                  {avatar && (
                    <div className="p-2">
                      <img
                        src={avatar}
                        className="card-img-top rounded sponsorship-template-image-landing"
                      />
                    </div>
                  )}
                  <div className="card-body pt-2 text-center">
                    <h4 className="mb-1 fw-bold">
                      {canShowPublicField(visibleFields, "first_name") &&
                        `${user.first_name} `}

                      {canShowPublicField(visibleFields, "last_name") &&
                        `${user.last_name}`}
                    </h4>

                    {page.general_sponsorship_amount && unpaidSponsorshipsCount(user.id) > 1 &&
                      <p className='mb-0' style={{fontSize: '13px', textAlign: 'center'}}>
                        <b>{`${unpaidSponsorshipsCount(user.id)} of ${totalSponsorshipCount(user.id)} sponsorships available`}</b>
                      </p>
                    }

                    {page.general_sponsorship_amount && userSponsorshipAmount(user) && userSponsorshipAmount(user).length > 1 &&
                          <div className='form-group'>
                              <div className="input-group">
                                  <Select
                                      className="w-100 select-audience"
                                      classNamePrefix="select-audience"
                                      value={currentSelection ? currentSelection : userSponsorshipAmount(user)[0]}
                                      onChange={(value) => handleInputChange(value)}
                                      options={userSponsorshipAmount(user)}
                                      getOptionLabel={option => `$${getAmounts(option)} / Month`}
                                      getOptionValue={option => option.id }
                                  />
                              </div>
                          </div>
                      }

                      {/* Only one sponsorship amount available */}
                      {page.general_sponsorship_amount && userSponsorshipAmount(user) && userSponsorshipAmount(user).length == 1 &&
                        <div className='mt-3' style={{textAlign: 'center'}}>
                            <h5 style={{fontSize: '1rem'}}>Sponsor: {`$${getAmounts(userSponsorshipAmount(user)[0])} / Month`}</h5>
                        </div>
                      }
                      
                      {page.general_sponsorship_amount && !userSponsorshipAmount(user) &&
                        <div className='mt-3' style={{textAlign: 'center'}}>
                          <h5 style={{fontSize: '1rem'}}>Sponsor: {`$${getAmounts()} / Month`}</h5>
                        </div>
                      }

                      <div>
                        <a
                          className="btn btn-sm"
                          onClick={() => {
                            setSelectedUser(user);
                            setIsModalOpen(true);
                          }}
                          style={{ color: page.button_color, borderColor: page.button_color, marginTop: '10px', marginRight: '1px' }}
                        >
                          Learn More
                        </a>
                        <a
                          className="btn btn-sm btn-primary"
                          href={visitSponsorPage(user)}
                          target='_top'
                          style = {{backgroundColor: page.button_color, borderColor: page.button_color, color: buttonTextColor, marginTop: '10px'}}
                        >
                          {page.button_text && <>{page.button_text}</>}
                          {!page.button_text && <>Sponsor</>}
                        </a>
                      </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      }
      {isModalOpen && (
        <div>
          <div>
            <div className='mb-3 d-flex justify-content-betweenn'>
              <div className='col-md-12'>
                <div style={{cursor: 'pointer', width: 'fit-content', padding: '15px'}} onClick={() => setIsModalOpen(false)}>
                  <span><i className="fa fa-chevron-left mr-2"></i> Back</span>
                </div>
              </div>
            </div>
            <div className="sponsorship-template-title text-center">
              Sponsor{" "}
              {canShowPublicField(visibleFields, "first_name") &&
                `${selectedUser.first_name} `}{" "}
              {canShowPublicField(visibleFields, "last_name") &&
                `${selectedUser.last_name}`}
            </div>
            <div className="sponsorship-template-subtitle text-center">
              {!page.use_payments && (
                <>
                  Click "{page.button_text && <>{page.button_text}</>}
                  {!page.button_text && <>Sponsor</>}" to set up your account,
                  and let us know you are interested in sponsoring
                  <strong>
                    {" "}
                    {canShowPublicField(visibleFields, "first_name") &&
                      `${selectedUser.first_name} `}{" "}
                    {canShowPublicField(visibleFields, "last_name") &&
                      `${selectedUser.last_name}`}
                  </strong>
                </>
              )}

              {page.use_payments && (
                <>
                  Click "{page.button_text && <>{page.button_text}</>}
                  {!page.button_text && <>Sponsor</>}" to set up your account
                  and sponsor
                  <strong>
                    {" "}
                    {canShowPublicField(visibleFields, "first_name") &&
                      `${selectedUser.first_name} `}
                    {canShowPublicField(visibleFields, "last_name") &&
                      `${selectedUser.last_name}`}
                  </strong>
                </>
              )}
            </div>
            <div className="row">
              <div className="col-md-6 text-center">
                <img
                  src={getUserAvatar(selectedUser)}
                  className="rounded sponsorship-template-image"
                  alt="Student Profile Picture"
                  style={{width: 'fit-content !important'}}
                />
                <div className="sponsorship-template-name">
                  {canShowPublicField(visibleFields, "first_name") &&
                    `${selectedUser.first_name} `}
                  {canShowPublicField(visibleFields, "last_name") &&
                    `${selectedUser.last_name}`}
                </div>
                <div className="sponsorship-template-age">
                  {canShowPublicField(visibleFields, "birthday") &&
                    selectedUser.birthday != null &&
                    selectedUser.birthday +
                      " (" +
                      defineAge(selectedUser.birthday) +
                      " years old)"}
                </div>

                {page.general_sponsorship_amount && unpaidSponsorshipsCount(selectedUser.id) > 1 &&
                  <p className='mb-0'><b>{`${unpaidSponsorshipsCount(selectedUser.id)} of ${totalSponsorshipCount(selectedUser.id)} sponsorships available`}</b></p>
                }

                {page.general_sponsorship_amount && userSponsorshipAmount(selectedUser) && userSponsorshipAmount(selectedUser).length > 1 &&
                    <div className='form-group' style={{maxWidth: '200px', margin: 'auto'}}>
                        <div className="input-group">
                            <Select
                                className="w-100 select-audience"
                                classNamePrefix="select-audience"
                                value={currentSelection ? currentSelection : userSponsorshipAmount(selectedUser)[0]}
                                onChange={(value) => handleInputChange(value)}
                                options={userSponsorshipAmount(selectedUser)}
                                getOptionLabel={option => `$${getAmounts(option)} / Month`}
                                getOptionValue={option => option.id }
                            />
                        </div>
                    </div>
                }

                {/* Only one sponsorship amount available */}
                {page.general_sponsorship_amount && userSponsorshipAmount(selectedUser) && userSponsorshipAmount(selectedUser).length == 1 &&
                  <div className='mt-3' style={{textAlign: 'center'}}>
                      <h5 style={{marginBottom: '0px'}}>Sponsor: {`$${getAmounts(userSponsorshipAmount(selectedUser)[0])} / Month`}</h5>
                  </div>
                }
                
                {page.general_sponsorship_amount && !userSponsorshipAmount(selectedUser) &&
                  <div className='mt-3' style={{textAlign: 'center'}}>
                    <h5 style={{marginBottom: '0px'}}>Sponsor: {`$${getAmounts()} / Month`}</h5>
                  </div>
                }
                <a
                  className="btn btn-sm btn-primary mt-3"
                  href={visitSponsorPage(selectedUser)}
                  target="_top"
                  style = {{backgroundColor: page.button_color, borderColor: page.button_color, color: buttonTextColor}}
                >
                  {page.button_text && <>{page.button_text}</>}
                  {!page.button_text && <>Sponsor</>}
                </a>
              </div>
              <div className="col-md-6 text-left">
                {visibleFields.map((field) => {
                  if (
                    field.system_key === "first_name" ||
                    field.system_key === "last_name" ||
                    field.system_key === "birthday"
                  ) {
                    return null;
                  }

                  const value = getFieldValues(selectedUser, field);
                  return (
                    <div>
                      {value != "" && (
                        <div
                          key={field.id}
                          className="mb-2 sponsorship-template-fields"
                        >
                          <p className="text-bold small sponsorship-template-field-name">
                            {field.name}
                          </p>
                          {value ? (
                            <p className="text-muted small sponsorship-template-field-value">
                              {field.value_type == 'link' &&
                                 <a href={value} target="_top">{ field.anchor_text ? field.anchor_text : field.name }</a> 
                              }
                              {field.value_type !== 'link' &&
                                <span>{value}</span>
                              }
                            </p>
                          ) : (
                            <p className="text-muted small sponsorship-template-field-value">
                              No data available.
                            </p>
                          )}
                        </div>
                      )}
                    </div> 
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
